import { useGetPromotionsQuery } from "../../../app/features/courses/courses.api";
import type { IPublicCourseResponse } from "../../../app/features/courses/courses.types";
import useError from "../../../hooks/useError";
import PromotionCard from "../../../pages/user/userDiscount/_components/PromotionCard";

type Props = {
  course?: IPublicCourseResponse;
};

export default function PromotionList({ course }: Props) {
  const {
    data: promotionData,
    isLoading: isPromotionLoading,
    error,
  } = useGetPromotionsQuery({
    activeOnly: true,
    hasCode: true,
    limit: 10,
  });
  useError(error, "ডিসকাউন্ট অফার লোড করা যায়নি");

  const strictCourseCoupons = course?.uuid
    ? promotionData?.items?.filter((c) =>
        c.rules?.targets?.includeCourseUuids?.includes(course?.uuid),
      ) || []
    : [];

  if (isPromotionLoading || strictCourseCoupons?.length <= 0) {
    return null;
  }

  return (
    <div className="mt-4 space-y-4">
      {strictCourseCoupons?.map((promotion) => (
        <PromotionCard promotion={promotion} key={promotion?.id} />
      ))}
    </div>
  );
}
